const defaultExtendedMetadata = {
  "1": {
    upperFields: [{ type: "date", name: "cdaDate", label: "Fecha", value: "" }],
    lowerFields: [{ type: "switch", name: "cda", label: "¿Enviado?", value: false }]
  },
  "2": {
    upperFields: [{ type: "date", name: "feasibilityDate", label: "Fecha", value: "" }],
    lowerFields: [
      { type: "switch", name: "feasibility", label: "¿Enviado?", value: false },
      { type: "date", name: "feasibilitySentDate", label: "Fecha de envío", value: "" }
    ]
  },
  "3": {
    upperFields: [{ type: "date", name: "communicationFileDate", label: "Fecha de comunicación", value: "" }],
    lowerFields: []
  },
  "4": {
    upperFields: [{ type: "date", name: "suitabilityFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "5": {
    upperFields: [{ type: "date", name: "CElmFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "6": {
    upperFields: [{ type: "date", name: "CEIcFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "7": {
    upperFields: [{ type: "date", name: "AEMPSFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "8": {
    upperFields: [{ type: "date", name: "trialInsuranceFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "9": {
    upperFields: [{ type: "date", name: "financialReportFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "10": {
    upperFields: [{ type: "date", name: "contractFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "11": {
    upperFields: [{ type: "date", name: "protocolFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "12": {
    upperFields: [{ type: "date", name: "FDAFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "13": {
    upperFields: [{ type: "date", name: "labRangesFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "14": {
    upperFields: [],
    lowerFields: []
  },
  "15": {
    upperFields: [{ type: "date", name: "trainingLogFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "16": {
    upperFields: [{ type: "date", name: "researchBrochureFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "17": {
    upperFields: [{ type: "date", name: "confirmationLetterFileDate", label: "Fecha", value: "" }],
    lowerFields: [{ type: "switch", name: "confirmationLetterFile", label: "¿Enviado?", value: false }]
  },
  "18": {
    upperFields: [{ type: "date", name: "promoterConfirmationFileDate", label: "Fecha", value: "" }],
    lowerFields: [{ type: "switch", name: "promoterConfirmationFile", label: "¿Enviado?", value: false }]
  },
  "19": {
    upperFields: [{ type: "date", name: "CVsDate", label: "Fecha de vencimiento", value: "" }],
  },
  "20": {
    upperFields: [{ type: "date", name: "GCPDate", label: "Fecha de vencimiento", value: "" }],
  },
  "21": {
    upperFields: [
      { type: "date", name: "receptionStartVisitFileDate", label: "Fecha de recepción", value: "" }, 
      { type: "date", name: "scheduledStartVisitFileDate", label: "Fecha programada de la visita de inicio", value: "" }
    ],
    lowerFields: []
  },
  "22": {
    upperFields: [{ type: "date", name: "centerActivationDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "23": {
    upperFields: [{ type: "date", name: "activationFileDate", label: "Fecha", value: "" }],
    lowerFields: [{ type: "switch", name: "activationFile", label: "¿Enviado?", value: false }]
  },
  "24": {
    upperFields: [{ type: "date", name: "acceptanceFileDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "25": {
    upperFields: [],
    lowerFields: []
  },
  "26": {
    upperFields: [],
    lowerFields: []
  },
  "27": {
    upperFields: [{ type: "date", name: "recistTableDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "28": {
    upperFields: [{ type: "date", name: "newslettersDate", label: "Fecha", value: "" }],
    lowerFields: [{ type: "switch", name: "newsletters", label: "¿Enviado?", value: false }]
  },
  "29": {
    upperFields: [{ type: "date", name: "actsDate", label: "Fecha", value: "" }],
    lowerFields: []
  },
  "30": {
    upperFields: [{ type: "date", name: "recruitmentClosureDate", label: "Fecha de cierre", value: "" }],
    lowerFields: []
  },
  "31": {
    upperFields: [
      { type: "date", name: "closingVisitDate", label: "Fecha de visita", value: "" }, 
      { 
        type: "select", 
        name: "closingVisitType", 
        label: "Tipo de visita realizada", 
        options: [
          { label: "clinicalTrials.visitType.remote", value: "Remote" }, 
          { label: "clinicalTrials.visitType.onSite", value: "OnSite" }
        ], 
        multi: false, 
        clearable: true 
      }
    ],
    lowerFields: []
  },
  "32": {
    upperFields: [],
    lowerFields: []
  },
  "34": {
    upperFields: [{ type: "date", name: "dangerousGoodDate", label: "Fecha de vencimiento", value: "" }],
  },
  "35": {
    upperFields: [{ type: "date", name: "iataDate", label: "Fecha de vencimiento", value: "" }],
  },
};

export default defaultExtendedMetadata;
